import React, { Component } from "react";
import { Col } from "reactstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import LoadingImage from "../../comum/components/LoadingImage";
import { observer } from "mobx-react";
import { buscaFiltrarVazio, buscaSemResultado } from "../../../utils/mensagens";

@observer
export default class TabelaAgendVgm extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const lista =
      this.props.dados && this.props.dados.length > 0 ? this.props.dados : [];
    return (
      <div>
        {this.props.loading ? (
          <LoadingImage />
        ) : (
          <React.Fragment>
            {this.props.filtrado ? (
              <ToolkitProvider
                keyField="Id"
                data={lista.slice()}
                columns={[...this.props.colunas]}
              >
                {props => (
                  <BootstrapTable
                    bootstrap4
                    striped
                    bordered={false}
                    noDataIndication={() => buscaSemResultado}
                    classes="tabela tabela-layout"
                    pagination={paginationFactory()}
                    defaultSorted={[...this.props.defaultSorted]}
                    {...props.baseProps}
                  />
                )}
              </ToolkitProvider>
            ) : (
              <Col className="px-0" xs={12}>
                <span className="mensagem-filtrar">{buscaFiltrarVazio}</span>
              </Col>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agend-vgm/componentes/TabelaAgendVgm.js